import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import {
  Component,
  Renderer2,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Inject,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-app-shell',
  templateUrl: './app-shell.component.html',
})
export class AppShellComponent implements  AfterViewInit {
  mobile: boolean;
  @ViewChild('divCreateText', { static: false }) divCreateText: ElementRef;

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}


  ngAfterViewInit() {
    const div = this.document.getElementById('svgLoader');
    div.outerHTML = `<div style = 'margin: 0;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);'
    ><img src='assets/img/images/generic_loader.gif' alt='Loading...'><div>`;
  }
}
